import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, EyeIcon, GhostIcon, MapIcon, UserIcon, SwordsIcon, PaletteIcon, ImageIcon } from 'lucide-react';
const cards = [{
  icon: BookOpenIcon,
  title: 'Historia del irezumi',
  desc: 'Orígenes, tradición y evolución del arte corporal japonés.'
}, {
  icon: EyeIcon,
  title: 'Símbolos y significados',
  desc: 'Dragones, koi, tigres y los elementos fundamentales.'
}, {
  icon: GhostIcon,
  title: 'Mitología japonesa',
  desc: 'Dioses, espíritus y leyendas sobrenaturales.'
}, {
  icon: MapIcon,
  title: 'Máscaras y criaturas legendarias',
  desc: 'Hannya, Oni, Kitsune, Tengu y Yokai.'
}, {
  icon: UserIcon,
  title: 'Composición corporal',
  desc: 'Mangas, espaldas, body suits y narrativa corporal.'
}, {
  icon: SwordsIcon,
  title: 'Filosofía samurái',
  desc: 'El código Bushido, honor y disciplina.'
}, {
  icon: PaletteIcon,
  title: 'Arte Edo y Ukiyo-e',
  desc: 'La influencia de los grabados en el tatuaje tradicional.'
}, {
  icon: ImageIcon,
  title: 'Tatuajes reales de referencia',
  desc: 'Composiciones legendarias y ejemplos visuales.'
}];
export function WhatYouLearn() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-376">
      <div className="max-w-6xl mx-auto" data-id="element-377">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-378">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-379">
            <span className="text-xs font-bold tracking-widest" data-id="element-380">
              🌸 QUÉ VAS A DESCUBRIR
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight max-w-3xl mx-auto" data-id="element-381">
            Un viaje visual por la{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-382">
              historia y el arte
            </span>{' '}
            del Japón
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-383">
          {cards.map((c, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.07,
          duration: 0.5
        }} whileHover={{
          y: -4
        }} className="bg-bg-warm p-7 rounded-3xl border border-line shadow-sm hover:shadow-lg transition-shadow" data-id="element-384">
              <div className="w-12 h-12 rounded-2xl flex items-center justify-center mb-5 bg-rose/10" data-id="element-385">
                <c.icon className="w-6 h-6 text-rose" data-id="element-386" />
              </div>
              <h3 className="font-serif text-xl md:text-2xl text-ink mb-2 leading-tight font-bold" data-id="element-387">
                {c.title}
              </h3>
              <p className="text-ink-soft text-sm leading-relaxed" data-id="element-388">{c.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}